import { extend, override } from 'flarum/common/extend';
import avatar from 'flarum/common/helpers/avatar';
import Link from 'flarum/common/components/Link';
import listItems from 'flarum/common/helpers/listItems';
import Badge from 'flarum/common/components/Badge';
import PostUser from 'flarum/forum/components/PostUser';
import UserCard from '../components/UserCard';
import userOnline from 'flarum/common/helpers/userOnline';
import username from 'flarum/common/helpers/username';
import { avatarsUrl } from '../../util';
import { getJwtUser } from '@speareducation/util/auth';
import { urls } from '@speareducation/util';

export default () => {
  extend(PostUser.prototype, 'oninit', function () {
    const post = this.attrs.post;
    const user = post.user();
    
    if (user) {
      const userId = user.id();

      getUserAddress(userId).then((result) => {
        this.address = result;
        m.redraw();
      });
    }
  });

  override(PostUser.prototype, 'view', function () {
    const post = this.attrs.post;
    const user = post.user();
    const badges = removeHiddenBadges(user.badges().toArray());
    const isDiscussionPage = this.attrs.isDiscussionPage ?? false;
    const canShowCard = !post.isHidden()  && app.session.user && this.attrs.cardVisible;

    const canSticky = post.isSticky || post.isStickiest || post.isTagSticky;
    const isStickied = canSticky && (post.isSticky() || post.isStickiest() || post.isTagSticky());

    if (isStickied) {
      badges.push(
        <Badge key="sticky" type="sticky" label={app.translator.trans('flarum-sticky.forum.badge.sticky_tooltip')} icon="fas fa-thumbtack" />,
      );
    }

    // If the current viewer is logged out, its not the index page,
    // and it is not the discussion post redact user img/info
    if (!app.session.user && !isDiscussionPage && post.number() != 1) {
      return (
        <div className="PostUser">
          <h3 className="PostUser-name">
            <img class='PostUser-anon' src={`${avatarsUrl}/0.jpg`}/>
            <span>Spear User</span>
          </h3>
        </div>
      );
    }

    if (!user) {
      return (
        <div className="PostUser">
          <h3 className="PostUser-name">
            {avatar(user, { className: 'PostUser-avatar' })} {username(user)}
          </h3>
        </div>
      );
    }

    return (
      <div className="PostUser">
        <h3 className="PostUser-name">
          <Link href={app.route.user(user)}>
            {avatar(user, { className: 'PostUser-avatar' })}
            {userOnline(user)}
            {username(user)}
          </Link>
        </h3>

        {canShowCard && (
          <UserCard 
            user={user} 
            className="UserCard--popover"
            isDiscussionPage={isDiscussionPage}
            address={this.address || 'Loading...'}
          />
        )}

        {badges?.length > 0 && <ul className="PostUser-badges badges">{listItems(badges)}</ul>}
      </div>
    );
  });
};

const removeHiddenBadges = userBadges => {
  return userBadges.filter((badge) => badge.attrs?.group?.isHidden() === 0);
};

const getUserAddress = async (userId) => {
  try {
    const res = await m.request({
      method: 'POST',
      url: `${urls.getBaseUrl('accounts')}/api/address/get-address/user/${userId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getJwtUser().jwtToken}`,
      },
    });

    if (res?.length > 0) {
      const primaryAddress = res.find((address) => address.billing === 1);

      return primaryAddress && primaryAddress.city && primaryAddress.state
        ? `${primaryAddress.city}, ${primaryAddress.state}`
        : 'N/A';
    } else {
      return 'N/A';
    }

  } catch (error) {
    console.error('Error retrieving address: ', error);
    return 'N/A';
  }
};
